import { EXTERNAL_HOME_LIST } from '@/constants/home'
import { PAGE_LIST } from '@/constants/new-credit'

export const PAGE_ID = {
  HOME_ENTRY: 'waitou_MXCreditCardH5_home_entry',
  MARKET_ENTRY: 'waitou_MXCreditCardH5_market_entry',
  LOGIN: 'waitou_MXCreditCardH5_login',
  GUIDE_ONE: 'waitou_MXCreditCardH5_guide_one',
  PERSON_INFO: 'waitou_MXCreditCardH5_person_info',
  PERSON_INFO_PAGE1: 'waitou_MXCreditCardH5_person_info_page1',
  PERSON_INFO_PAGE2: 'waitou_MXCreditCardH5_person_info_page2',
  CURP: 'waitou_MXCreditCardH5_curp',
  GUIDE_TWO: 'waitou_MXCreditCardH5_guide_two',
  AUTHORIZATION: 'waitou_MXCreditCardH5_authorization',
  STAGE_ONE_LOADING: 'waitou_MXCreditCardH5_stage_one_loading',
  WAITING: 'waitou_MXCreditCardH5_waiting',
  PASS: 'waitou_MXCreditCardH5_pass',
  REJECT: 'waitou_MXCreditCardH5_reject',
  DIVERSION: 'waitou_MXCreditCardH5_diversion',
  PERMANENT_REJECT: 'waitou_MXCreditCardH5_permanent_reject',
  EXPLAINATION: 'waitou_MXCreditCardH5_explaination',
  SUBMITTED: 'waitou_MXCreditCardH5_submitted',
  UPDATE: 'waitou_MXCreditCardH5_update',
  REAPPLY: 'waitou_MXCreditCardH5_reapply',
  UNIFIED_KYC: 'waitou_MXCreditCardH5_unified_kyc',
  APPROVAL: 'waitou_MXCreditCardH5_approval',
  ERROR: 'waitou_MXCreditCardH5_error',
  SAFETY_INTERCEPT: 'waitou_MXCreditCardH5_safety_intercept',
  MARKET_HOME: 'waitou_MXCreditCardH5_market_home',
  MARKET_TIMEOUT: 'waitou_MXCreditCardH5_market_timeout',
  MARKET_OFFLINE: 'waitou_MXCreditCardH5_market_offline',
  MARKET_LOADING: 'waitou_MXCreditCardH5_market_loading',
  APPLY_UNKNOWN: 'waitou_MXCreditCardH5_apply_unknown',
  HOME_UNKNOWN: 'waitou_MXCreditCardH5_home_unknown',
}

export const FLOW_PAGE_ID_MAP: Record<string, string> = {
  [PAGE_LIST.startNowPage]: PAGE_ID.GUIDE_ONE,
  [PAGE_LIST.cardSeparatePersonalInfo1]: PAGE_ID.PERSON_INFO,
  [PAGE_LIST.cardSeparatePersonalInfo1Page1]: PAGE_ID.PERSON_INFO_PAGE1,
  [PAGE_LIST.cardSeparatePersonalInfo1Page2]: PAGE_ID.PERSON_INFO_PAGE2,
  [PAGE_LIST.curpPage]: PAGE_ID.CURP,
  [PAGE_LIST.congratesPage]: PAGE_ID.GUIDE_TWO,
  [PAGE_LIST.creditGrantPage]: PAGE_ID.AUTHORIZATION,
  [PAGE_LIST.phaseOneLoading]: PAGE_ID.STAGE_ONE_LOADING,
  [PAGE_LIST.curpConflictChangeOneSubmitPage]: PAGE_ID.WAITING,
}

export const HOME_STATUS_PAGE_ID_MAP: Record<number, string> = {
  [EXTERNAL_HOME_LIST.STAGE_ONE_WAITTING]: PAGE_ID.WAITING,
  [EXTERNAL_HOME_LIST.STAGE_ONE_PASSED]: PAGE_ID.PASS,
  [EXTERNAL_HOME_LIST.TEMP_REFUSED]: PAGE_ID.REJECT,
  [EXTERNAL_HOME_LIST.INTRO_TO_LOAN]: PAGE_ID.DIVERSION,
  [EXTERNAL_HOME_LIST.FOREVER_REFUSED]: PAGE_ID.PERMANENT_REJECT,
  [EXTERNAL_HOME_LIST.BLACK_LIST]: PAGE_ID.EXPLAINATION,
  [EXTERNAL_HOME_LIST.APPLY_WAITING]: PAGE_ID.SUBMITTED,
  [EXTERNAL_HOME_LIST.SP_KYC]: PAGE_ID.UPDATE,
  [EXTERNAL_HOME_LIST.RETRY]: PAGE_ID.REAPPLY,
  [EXTERNAL_HOME_LIST.UNIFIED_KYC]: PAGE_ID.UNIFIED_KYC,
  [EXTERNAL_HOME_LIST.USE_CARD]: PAGE_ID.APPROVAL,
  [EXTERNAL_HOME_LIST.AUTH_SUCCESS]: PAGE_ID.APPROVAL,
}

export const getFlowPageId = (page?: string): string => {
  if (!page) return PAGE_ID.APPLY_UNKNOWN
  return FLOW_PAGE_ID_MAP[page] || PAGE_ID.APPLY_UNKNOWN
}

export const getHomeStatusPageId = (status?: number): string => {
  if (typeof status !== 'number') return PAGE_ID.HOME_UNKNOWN
  return HOME_STATUS_PAGE_ID_MAP[status] || PAGE_ID.HOME_UNKNOWN
}
